import React, { Fragment } from 'react';
import { styles } from './ProductCompareTable.css';
import DomFont from '@jbhi-fi/lanyard-ui/font/DomFont';
import NegativeIcon from '@jbhi-fi/lanyard-ui/components/Icons/Negative';
import PositiveIcon from '@jbhi-fi/lanyard-ui/components/Icons/Positive';
import { ProductCompareTableSubSection } from './ProductCompareTableSubsection';
import { submitTracking } from '../../Tracking/utils/shopifyActionTrackingHelper';

interface ProductCompareTableSectionProps {
  heading: string;
  specs: any;
  numItems: number;
  showDifferences: boolean;
  shouldShowFiller: boolean;
}

export const ProductCompareTableSection = ({
  heading,
  specs,
  numItems,
  showDifferences,
  shouldShowFiller,
}: ProductCompareTableSectionProps) => {
  const [isExpanded, setIsExpanded] = React.useState(true);

  const handleExpandToggle = () => {
    submitTracking({
      event: 'productCompare',
      action: `${heading}-accordion-compare-${isExpanded ? 'collapse' : 'expand'}`,
      trackingDescriptor: {
        page: 'comparePage',
      },
      gtm: {},
    });
    setIsExpanded(prev => !prev);
  };

  return (
    <tbody>
      <tr className={styles.sectionHeadingRow}>
        <th className={styles.sectionHeading}>
          <DomFont>{heading}</DomFont>
        </th>
        <th colSpan={shouldShowFiller ? numItems : numItems - 1} className={styles.sectionHeadingFiller}></th>
        <th className={styles.sectionHeadingFillerLast}>
          <div className={styles.sectionHeadingMinimizeIcon}>
            {isExpanded ? (
              <NegativeIcon cursor="pointer" onClick={handleExpandToggle} />
            ) : (
              <PositiveIcon cursor="pointer" onClick={handleExpandToggle} />
            )}
          </div>
        </th>
      </tr>
      {isExpanded ? (
        Array.isArray(specs) ? (
          <ProductCompareTableSubSection
            specs={specs}
            showDifferences={showDifferences}
            shouldShowFiller={shouldShowFiller}
          />
        ) : (
          <>
            {Object.keys(specs).map(subsection =>
              specs[subsection].length > 0 ? (
                <Fragment key={subsection}>
                  <tr>
                    <th className={styles.subsectionHeadingFirstColumn}>{subsection}</th>
                    <th className={styles.subsectionHeading} colSpan={shouldShowFiller ? 3 : numItems}></th>
                  </tr>
                  <ProductCompareTableSubSection
                    key={subsection}
                    specs={specs[subsection]}
                    showDifferences={showDifferences}
                    shouldShowFiller={shouldShowFiller}
                  />
                </Fragment>
              ) : null
            )}
          </>
        )
      ) : null}
    </tbody>
  );
};
